@mixin background {
  border-radius: 10px;
}

.drinks-row {
  .drinks-row-block1 {
    @include background;
    .col-md-custom {
      padding: 0 15px 0 15px;
      div {
        text-align: center;
        border-radius: 6px;
        padding-top: 8px;
        padding-bottom: 8px;
        font-weight: 100;
        input {
          border: none;
          outline: none;
          padding-left: 20px;
        }
      }
    }
    button {
      width: 100%;
      outline: none;
      border: none;
      padding: 12px;
      box-shadow: 0 3px 2px 0 black;
    }
  }
  .drinks-row-block2 {
    @include background;
    div {
      text-align: center;
      img {
        height: 70px;
        padding-top: 10px;
        cursor: pointer;
      }
      @for $i from 1 through 55 {
        @if ($i !=29) {
          $url: '../../../../../assets/images/Cups/cup_#{$i}.imageset/cup_#{$i}.png';
          .img#{$i} {
            content: url('#{$url}');
          }
        }
      }
      span {
        font-size: 12px;
        cursor: pointer;
      }
    }

  }
}


// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-dev-vm-baristadj/src/app/components/recipe/editor/drinks/drinks.scss